var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Company",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2859",
    "data-name": "Rectangle 2859",
    width: 20,
    height: 2,
    transform: "translate(0 18)",
    fill: "#600097"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2860",
    "data-name": "Rectangle 2860",
    width: 10,
    height: 2,
    transform: "translate(5)",
    fill: "#600097"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2861",
    "data-name": "Rectangle 2861",
    width: 2,
    height: 2,
    transform: "translate(6 6)",
    fill: "#600097"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2862",
    "data-name": "Rectangle 2862",
    width: 2,
    height: 2,
    transform: "translate(12 6)",
    fill: "#600097"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2863",
    "data-name": "Rectangle 2863",
    width: 2,
    height: 2,
    transform: "translate(6 10)",
    fill: "#600097"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 2,
    height: 2,
    transform: "translate(12 10)",
    fill: "#600097"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2865",
    "data-name": "Rectangle 2865",
    width: 2,
    height: 2,
    transform: "translate(6 14)",
    fill: "#600097"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2866",
    "data-name": "Rectangle 2866",
    width: 2,
    height: 4,
    transform: "translate(12 14)",
    fill: "#600097"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13111",
    "data-name": "Path 13111",
    d: "M4,4H16V18H4ZM2,20H18V2H2Z",
    fill: "#600097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.a9dd887256f295f649a090489ca0b4e9.svg";
export { ForwardRef as ReactComponent };